import { render, staticRenderFns } from "./Secured.vue?vue&type=template&id=6bc6b653&scoped=true"
import script from "./Secured.vue?vue&type=script&lang=ts"
export * from "./Secured.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc6b653",
  null
  
)

export default component.exports